export enum PriceWeights {
  canChangePrice = 700,
  cannotChangePrice = 400
}
